interface Props {
	className?: string;
}

// Placeholder cursive scribble for a regular signer; stylised, not real.
// ViewBox 100x40, caller sizes via parent CSS.
export const InvestorCursive = ({ className }: Props) => (
	<svg
		className={className}
		viewBox="0 0 100 40"
		xmlns="http://www.w3.org/2000/svg"
		preserveAspectRatio="xMidYMid meet"
		data-testid="scribble-investor-cursive"
	>
		<path
			d="M6 28 C 14 8, 22 8, 26 26 S 38 36, 44 18 S 58 6, 64 24 Q 70 34, 78 20 T 94 22"
			stroke="#1a1a2e"
			strokeWidth="1.6"
			strokeLinecap="round"
			strokeLinejoin="round"
			fill="none"
		/>
		<path
			d="M40 30 L 88 32"
			stroke="#1a1a2e"
			strokeWidth="1"
			strokeLinecap="round"
			fill="none"
			opacity="0.7"
		/>
	</svg>
);
